import { render, staticRenderFns } from "./AumentoSueldoModal.vue?vue&type=template&id=be6a5afc"
import script from "./AumentoSueldoModal.vue?vue&type=script&lang=js"
export * from "./AumentoSueldoModal.vue?vue&type=script&lang=js"
import style0 from "./AumentoSueldoModal.vue?vue&type=style&index=0&id=be6a5afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports